export function PageProgress() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="border-brand-200 border-t-brand-600 h-8 w-8 animate-spin rounded-full border-4" />
    </div>
  );
}
